export const colorPickerToolTip = () => ({
  color: "white",
  display: "flex",
  flexDirection: "row",
  padding: "20px",
});

export const colorPickerIcon = (backgroundColor) => ({
  background: `${backgroundColor}`,
  border: "solid 1px",
  borderColor: "white",
  borderRadius: "1000px",
  width: "20px",
  height: "20px",
  ml: "10px",
});
